import { useEffect, useState } from 'react';
import { APP_DOMAIN } from 'utils/urls';

export type Club = {
  key: string;
  locationId: string;
  clubName: string;
  clubLogo: string;
};

export function useClubs() {
  const [clubs, setClubs] = useState<Club[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClubs = async () => {
      try {
        const mediaBase = `https://media.${APP_DOMAIN}`;
        const res = await fetch(`${mediaBase}/meta/club.json`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const data = await res.json();

        // Data is a dictionary: { "key": { locationid, clubname, clublogo, ... } }
        const list: Club[] = Object.entries(data).map(([key, val]: [string, any]) => ({
          key,
          locationId: val.locationid || val.locationId || '',
          clubName: val.clubname || val.clubName || key,
          clubLogo: val.clublogo || val.clubLogo || ''
        }));

        list.sort((a, b) => a.clubName.localeCompare(b.clubName));
        setClubs(list);
      } catch (e) {
        console.warn('[useClubs] Failed to fetch clubs:', e);
      } finally {
        setLoading(false);
      }
    };

    fetchClubs();
  }, []);

  return { clubs, loading };
}
